import { X } from "lucide-react";

export default function ModalShell({ children, onClose, title, wide, testid }) {
    return (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 overflow-y-auto" data-testid={testid}>
            <div className={`bg-white rounded-sm w-full ${wide ? "max-w-3xl" : "max-w-md"} max-h-[90vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
                    <h2 className="font-display font-black text-xl">{title}</h2>
                    <button onClick={onClose} className="p-1 rounded-sm hover:bg-gray-100" data-testid="modal-close">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="p-5">{children}</div>
            </div>
        </div>
    );
}
